import {
  Directive,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from "@angular/core";

@Directive({
  selector: "[appDragAndDrop]",
})
export class DragAndDropDirective {
  @Output() file: EventEmitter<File> = new EventEmitter();
  @Output() isOver: EventEmitter<boolean> = new EventEmitter();

  constructor() {}

  @HostListener("dragover", ["$event"])
  public onDragEnter(event: any) {
    this.isOver.emit(true);
    this.prevent(event);
  }

  @HostListener("dragleave", ["$event"])
  public onDragLeave() {
    this.isOver.emit(false);
  }

  @HostListener("drop", ["$event"])
  public onDrop(event: any) {
    this.isOver.emit(false);
    this.prevent(event);

    const transfer = this.getTransfer(event);
    if (!transfer) {
      return;
    }
    this.file.emit(transfer.files[0]);
  }

  private getTransfer(event: any) {
    return event.dataTransfer
      ? event.dataTransfer
      : event.originalEvent.dataTransfer;
  }

  //Validations
  private prevent(event: any) {
    event.preventDefault();
    event.stopPropagation();
  }
}
